// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"4e9b734c","145":"674fb23e","234":"e7aef980","377":"45f05826","445":"866e89f6","529":"45911267","551":"b947d3c3","631":"4fe5bccb","666":"6a6ceef7","922":"028a796c"}[chunkId] + ".chunk.js";
};